import { z } from 'zod';


export const createLocationSchema = z.object({
  name: z
    .string()
    .min(1, 'checkInLocation:form.validation.nameRequired')
    .max(200, 'checkInLocation:form.validation.nameMaxLength'),
  address: z
    .string()
    .min(1, 'checkInLocation:form.validation.addressRequired')
    .max(500, 'checkInLocation:form.validation.addressMaxLength'),
  communeId: z
    .union([z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(), z.null()])
    .nullable()
    .default(null),
  isRemoteWork: z.boolean().default(false),
});

export type CreateLocationFormData = z.infer<typeof createLocationSchema>;
